import React from "react";
import { useLocation } from "react-router-dom";

import ComponentContainer from "../ComponentContainer/ComponentContainer";
import AppStore from "../StoreButtons/AppStore";
import GooglePlay from "../StoreButtons/GooglePlay";

import style from "./SuccessScreen.module.css";

export default function SuccessScreen() {
  const search = useLocation().search;

  const title = `Congratulations! You have successfully joined the track`;
  const description =
    "Please download The Athlete’s App. In the app you will be able to chat with your team, view workouts, enter scores, and much more! To log in to the app, you will use the email and password created in the previous step. ";
  const footer =
    "You can also login to your account through the desktop version.";

  return (
    <ComponentContainer
      title="The Athletes App"
      
      innerContainerStyles={style.innerContainerStyles}
    >
      <div className="text-center pl-5 pr-5">
        <h4 className="mt-3">{title}</h4>
        <p className="mt-3">{description}</p>

        <div className={`${style.appButtonsBox}`}>
          <GooglePlay
            appLink={
              "https://play.google.com/store/apps/details?id=com.crossfitapp"
            }
          />
          <AppStore
            appLink={
              "https://apps.apple.com/us/app/theathletesapp/id1587319907"
            }
          />
        </div>

        <p>
          {footer} <a href="/">Dashboard</a>{" "}
        </p>
      </div>
    </ComponentContainer>
  );
}
